export default "__VITE_ASSET__ySRuTwiq__"